<script>
import apiConnector from '@/epersonam/apiConnector';
import error from '../error';
import vSelect2 from '../vSelect2';
import richTextEditor from '../richTextEditor';
import userMedia from '../userMedia';
import datepicker from '../datepicker';
import timepicker from '../timepicker';
const emptyNewPaisVerification = () => {
  return {
    user_id: window.config.user.id,
    user_full_name: `${window.config.user.surname} ${window.config.user.firstname}`,
    updated_who: window.config.user.id,
    modifier_full_name: window.config.user.surname + ' ' + window.config.user.firstname,
    modifier_date: moment().format(window.i18nJS.time.formats.aux),
    modifier_url_small: window.config.user.avatar,
    created_who: window.config.user.id,
    creator_full_name: window.config.user.surname + ' ' + window.config.user.firstname,
  };
};

export default {
  name: 'paisVerifications',
  template: '#pais-verifications-vue',
  components: {
    error,
    vSelect2,
    richTextEditor,
    userMedia,
    datepicker,
    timepicker,
  },
  props: ['loadVerification', 'persisted', 'canManage', 'postPath', 'patchPath'],
  data() {
    return {
      error: false,
      paisVerifications: [],
      newPaisVerification: emptyNewPaisVerification(),
      attributes: [
        'id',
        'created_who',
        'updated_who',
        'user_id',
        'targets',
        ',actions',
        'datetimeprev',
        'start',
        'data_prox_ver',
        'status',
      ],
      indexEl: null,
      firstLoad: true,
      POPUP_ANIMATION: 500,
    };
  },
  computed: {
    sortByDateTimePrev: function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.paisVerifications.sort(function (a, b) {
        return new Date(a['dateprev'] + ' ' + a['timeprev']) >= new Date(b['dateprev'] + ' ' + b['timeprev']);
      });
    },
    currentUserId() {
      return window.config.user.id;
    },
  },
  mounted() {
    if (this.persisted) {
      const tab = $('#verification-tab');
      if (tab.length > 0) {
        tab.on('shown', () => this.loadPaisVerifications());
        if (location.href.split('#', 2)[1] === tab.prop('href').split('#', 2)[1]) {
          // if page lands on http://...pais/n/edit#tab_pais_verifications
          this.loadPaisVerifications();
        }
      } else {
        this.loadPaisVerifications();
      }
    }
    $('#modal-pai-verification').on('hidden', () => {
      this.newPaisVerification = emptyNewPaisVerification();
      this.indexEl = null;
    });
  },
  methods: {
    loadPaisVerifications() {
      if (this.firstLoad) {
        this.error = false;
        Loader.show();
        apiConnector()
          .get(this.loadVerification)
          .then((res) => {
            this.paisVerifications = res.data;
            this.firstLoad = false;
            Loader.hide();
          })
          .catch((err) => {
            Loader.hide();
            this.error = true;
          });
      }
    },
    savePaisVerification() {
      Loader.show();
      this.disableModalButton();
      if (this.persisted) {
        // behaviour if is a exist pai
        if (this.indexEl == null) {
          apiConnector()
            .post(this.postPath, { pais_verification: this.newPaisVerification })
            .then((result) => {
              this.newPaisVerification = result.data;
              this.paisVerifications.push(this.newPaisVerification);
              $('#modal-pai-verification').modal('hide');
              this.enableModalButton();
              Loader.hide();
            })
            .catch(() => {
              Loader.hide();
              this.enableModalButton();
              this.error = true;
            });
        } else {
          apiConnector()
            .patch(this.patchPath.replace('PAIS_VERIFICATION__ID', this.newPaisVerification.id), {
              pais_verification: this.newPaisVerification,
            })
            .then((result) => {
              this.newPaisVerification = result.data;
              $('#modal-pai-verification').modal('hide');
              this.enableModalButton();
              this.$set(this.paisVerifications, this.indexEl, JSON.parse(JSON.stringify(this.newPaisVerification)));
              Loader.hide();
            })
            .catch(() => {
              Loader.hide();
              this.enableModalButton();
              this.error = true;
            });
        }
      } else {
        // behaviour if is a new pai
        this.newPaisVerification['datetimeprev'] = this.newPaisVerification.dateprev + ' ' + this.newPaisVerification.timeprev;
        if (this.newPaisVerification.date) {
          this.newPaisVerification['start'] = this.newPaisVerification.date + ' ' + moment().format('H:mm');
        } else {
          this.newPaisVerification['start'] = null;
        }

        if (this.indexEl == null) {
          this.paisVerifications.push(this.newPaisVerification);
        } else {
          this.$set(this.paisVerifications, this.indexEl, JSON.parse(JSON.stringify(this.newPaisVerification)));
        }
        $('#modal-pai-verification').modal('hide');
        this.enableModalButton();
        Loader.hide();
      }
    },
    addPaisVerification() {
      this.error = false;
      Loader.show();
      this.indexEl = null;
      this.newPaisVerification['permissions'] = { edit: true, destroy: true };
      $('#modal-pai-verification').modal('show');
      Loader.hide();
    },
    editPaisVerification(paisVerification, ix) {
      this.error = false;
      Loader.show();
      this.indexEl = ix;
      this.newPaisVerification = JSON.parse(JSON.stringify(paisVerification));
      $('#modal-pai-verification').modal('show');
      Loader.hide();
    },
    showPaisVerification(paisVerification) {
      this.error = false;
      Loader.show();
      this.newPaisVerification = JSON.parse(JSON.stringify(paisVerification));
      $('#modal-pai-verification').modal('show');
      Loader.hide();
    },
    disableModalButton() {
      $('.modal-footer').addClass('not-clickable');
    },
    enableModalButton() {
      setTimeout(() => {
        $('.modal-footer').removeClass('not-clickable');
      }, this.POPUP_ANIMATION);
    },
    removePaisVerification(paisVerification) {
      if (!confirm(window.i18nJS.command.confirm)) {
        return;
      }
      this.error = false;
      Loader.show();
      if (this.persisted) {
        apiConnector()
          .delete(this.patchPath.replace('PAIS_VERIFICATION__ID', paisVerification.id))
          .then(() => {
            this.paisVerifications = this.paisVerifications.filter((t) => t.id !== paisVerification.id);
            Loader.hide();
          })
          .catch(() => {
            Loader.hide();
            this.error = true;
          });
      } else {
        this.paisVerifications = this.paisVerifications.filter((t) => t !== paisVerification);
        Loader.hide();
      }
    },
  },
};
</script>
